<h2 mat-dialog-title>Confirmar acción</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="btn btn-danger" (click)="onCancel()">Cancelar</button>
  <button mat-raised-button class="btn btn-primary ms-2" color="primary" (click)="onConfirm()">Confirmar</button>
</mat-dialog-actions>
